import { useEffect } from "react";
import { Route, Routes } from "react-router-dom";

import { setDocumentTitle } from "@/lib/documentTitle";

import { FoBankContactCard } from "./card";
import { FoBankContactNew } from "./new";
import { FoBankContactTable } from "./table";

export default function FoBankContacts() {
  useEffect(() => {
    setDocumentTitle("Quantilia | Contacts bancaires");
  }, []);

  return (
    <Routes>
      <Route index element={<FoBankContactTable />} />
      <Route path="/new" element={<FoBankContactNew />} />
      <Route path=":id" element={<FoBankContactCard />} />
    </Routes>
  );
}
